import { prioritiesApi } from 'Api/axios/priorities-api';
import { useState, useEffect } from 'react';
import type { PriorityFilterI, PriorityI } from 'types';

interface Props {
  init?: boolean;
}

const usePrioritiesApi = ({ init = false }: Props = {}) => {
  const [data, setData] = useState<Array<PriorityI>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchPriorities = async (filters: PriorityFilterI = {}) => {
    setLoading(true);
    const response = await prioritiesApi.readAll(filters);
    setData(response.data ?? []);
    setLoading(false);
    setError(response.error);
  };

  useEffect(() => {
    if (init) {
      fetchPriorities();
    }
  }, [init]);

  return {
    data,
    loading,
    error,
    fetchPriorities,
  };
};

export default usePrioritiesApi;
